import React from 'react';
import { Modal, ModalContent, Text } from '@cashfree-intl/coherent';

import { Image } from 'components/Image';

import success from '../../../images/icons/success-icon-with-border.svg';

const InstantRefundsActivationSuccessfulModal = () => (
  <Modal open $maxWidth={480}>
    <ModalContent className="p-4">
      <div className="text-center">
        <Image src={success} alt="" />
        <Text variant="h20" strong className="mt-2 mb-3">
          Congratulations!
        </Text>
        <Text variant="b14" color="bodyLight">
          You’ve successfully activated Instant Refunds <br />
          on your account.
        </Text>
      </div>
    </ModalContent>
  </Modal>
);

export default InstantRefundsActivationSuccessfulModal;
